//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import {formatTime,guid} from "@/utils/common"
    import {BASIC,FLYBACK_URL} from "@/config/constant"
    import promise from '@/axios/promise';
import { stat, constants } from 'fs';
    export default{
        name :'dayReport',
        data(){
            return {
                calDate:this.$route.query.calDate,
                list:'',
                week:'',
                starDay:'',
                endDay:"",
                year:'',
                month:0,
                index:'',
                dataList:[],
                flyBackList:[],
                data:{
                   planMonth:'2018-11',
                   currDate:'2018-11-27',
                   dayReportList:[], 
                   reportData:{
                    id:'',
                    signId:'',
                    reportTime:this.$route.query.reportDate,
                    reportAddr:'',
                    signTime:'',
                    signAddr:'',
                    signCity:'',
                    reportLongitude:'',
                    reportDimension:'',
                    reportCityCode:'',
                    reportCity:'',
                    reportPlace:'',
                    status:'',
                    creater:'',
                    createTime:'',
                    deptId:'',
                    deptCode:'',
                    totalHour:'',
                    totalPrice:0,
                    deptName:'',
                    grade:'',
                    userType:'',
                    reportDetailList:[],
                   }
                },

            }
        },
        methods:{
            //返回
            goBack(){
                this.$router.push({path:'/'});
            },
            writeReport(){  
                var dayStr=this.index+"";
                if(this.index<10){
                    dayStr="0"+dayStr
                }
                var monthStr=""+this.month;
                if(this.month<10){
                    monthStr="0"+monthStr
                }
                var reportDate=new Date(this.year+'-'+monthStr+'-'+dayStr);   
                var dayReport=null;
                for(var i=0;i<this.data.dayReportList.length;i++){
                        var item=this.data.dayReportList[i];
                        var  reportTime=new Date(item.reportTime) ;
                        if(formatTime(reportTime,'yyyy-MM-dd') == formatTime(reportDate,'yyyy-MM-dd')){
                            dayReport=item;
                        }
                }
                var type="1";
                var reportDateStr=formatTime(reportDate,'yyyy-MM-dd');
                var id=guid();
                if(dayReport!=null && dayReport!=undefined){
                    id=dayReport.id;
                    type='2';
                }
                this.$router.push({path:'/app/workRep/dayReportAdd',query:{reportDate:reportDateStr,type:type,id:id}});
            },
            getClass(index){
                if(index==this.index){
                    return "checkedDay";
                }
                return "";
            },
            modifyClick(reportDate,reportDetail){
                var type=2;
                var id=reportDetail.mainId;
                var detailId=reportDetail.id;
                var status=reportDetail.status;
                if(status=='已通过'){
                    return false;
                }
                var reportDateStr=formatTime(reportDate,'yyyy-MM-dd');
                this.$router.push({path:'/app/workRep/dayReportModify',query:{reportDate:reportDateStr,type:type,id:id,detailId:detailId,status:status}});

            },
            //加在所在月份的数据
            getDayReportByMonth(){
                var dayStr=this.index+"";
                if(this.index<10){
                    dayStr="0"+dayStr
                }
                var monthStr=""+this.month;
                if(this.month<10){
                    monthStr="0"+monthStr
                }
                var reportMonth=new Date(this.year+'-'+monthStr+'-'+dayStr); 
                var self=this;
                promise({
                    url:BASIC+'/dayReport/list/month',
                    method:'get',
                    params:{month:formatTime(reportMonth,'yyyy-MM')}
                }).then(res=>{
                    if(res.code==0){
                        self.data.dayReportList=res.data;
                        this.updateDateList(res.data);
                        this.getInfo(self.index);
                    }
                });
            },
            //获取flyback 信息
            getFlybackInfo(){
                var dayStr=this.index+"";
                if(this.index<10){
                    dayStr="0"+dayStr
                }
                var monthStr=""+this.month;
                if(this.month<10){
                    monthStr="0"+monthStr
                }
                var condition={};
                condition.applyMonth=this.year+'-'+monthStr;
                var self=this;
                promise({
                    url:FLYBACK_URL+'/getFbListByMonth',
                    method:'post',
                    params:{condition:JSON.stringify(condition)}
                }).then(res=>{
                    self.flyBackList=res.list;
                    self.getDayReportByMonth();
                });

            },
            updateDateList(data){
                var maxDay=this.list;
                this.dataList=[];
                var currDate=new Date();
                for(var i=1;i<=maxDay;i++){
                    var reportData={};
                    var dayStr=i+"";
                    if(i<10){
                        dayStr="0"+dayStr
                    }
                    var monthStr=""+this.month;
                    if(this.month<10){
                        monthStr="0"+monthStr
                    }
                    var date=new Date(this.year+'-'+monthStr+'-'+dayStr);
                    var dayReport=undefined;
                    var flyBackList=[];
                    for(var j=0;j<this.data.dayReportList.length;j++){
                            var item=this.data.dayReportList[j];
                            var  reportTime=new Date(item.reportTime) ;
                            if(formatTime(reportTime,'yyyy-MM-dd') == formatTime(date,'yyyy-MM-dd')){
                                dayReport=item;
                            }
                    }
                    for(var j=0;j<this.flyBackList.length;j++){
                        var item=this.flyBackList[j];
                        var  reportTime=item.fbDate ;
                        if(reportTime == formatTime(date,'yyyy-MM-dd')){
                            var flyBackStatus=item.status;
                            if(flyBackStatus=='被驳回'){
                                item.statusClass="refused";
                            }else if(flyBackStatus=='已通过'){
                                item.statusClass="success"
                            }else{
                                 item.statusClass="wait";
                            }
                            var flybackType=item.flybackType;
                            if(flybackType=="申请"){
                                item.flybackTypeClass="appaly";
                                item.icon='static/images/flyBack3.png';
                                item.content=item.fbType;
                            }else{
                                 item.flybackTypeClass="discount";
                                 item.icon='static/images/discount2.png';
                                 item.content=item.discountAmt;
                            }
                            flyBackList.push(item);
                        }
                    }
                    reportData.flyBackList=flyBackList;
                    reportData.index=i;
                    var workHour=0;
                    var workSubsidy=0;
                    var status="已通过";
                    var statusClass="unReport";
                    if(dayReport!=null && dayReport!=undefined){
                        var refuseFlag=false;
                        var waitFlag=false;
                        dayReport.reportDetailList.forEach(element => {
                            //判断是否显示时间
                            var showReportTime=false;
                            if(this.formatDate(new Date(dayReport.reportTime))==this.formatDate(new Date(dayReport.createTime))){
                                showReportTime=true;
                            }
                           element.showReportTime=showReportTime;
                           workHour+=element.workHour;
                           workSubsidy+=element.workSubsidy; 
                           var status=element.status;
                           if(status=='被驳回'){
                                refuseFlag=true;
                           }
                           if(status=='待审批'){
                               waitFlag=true;
                           }
                        });
                        if(refuseFlag){
                            status="被驳回";
                            statusClass="refused";
                        }else if(waitFlag && !refuseFlag){
                            status="待审核";
                            statusClass="wait";
                        }else{
                            status="已通过";
                            statusClass="success"
                        }
                    }else{
                         status="逾期未填写";
                         statusClass="unReport";
                    }

                    if((currDate.getTime()<=date.getTime() || formatTime(currDate,'yyyy-MM-dd')== formatTime(date,'yyyy-MM-dd')) && statusClass=="unReport" ){
                         status="未到达";
                         statusClass="unReach";
                    }
                    reportData.statusClass=statusClass;
                    reportData.workHour=workHour;
                    reportData.workSubsidy=workSubsidy;
                    this.dataList.push(reportData);
                }
            },
            getId(val){
                return 'date'+val;
            },
             mGetDate(year, month){
                var d = new Date(year, month, 0);
                return d.getDate();
            },
            dateRech(year,month){
                var dayNum=this.mGetDate(year,month);
                this.list=dayNum;
                //当前月当天日期对象：
                var starDate=new Date(year, month, 0);
                //当前月第一天日期对象：
                starDate=new Date(starDate.setDate(1))
                //当前月第一天星期几:
                var weekday=starDate.getDay()
                this.starDay=weekday;
                this.dataList=[];
                this.getFlybackInfo();
                var total =42-parseInt(dayNum)-parseInt(weekday);
                if(total>=7){
                    this.endDay=total-7;
                }else{
                   this.endDay=total;  
                }
            
            },
            //日历点击查看当天
            getInfo(index){
                this.index=index;
                var self=this;
                var dayStr=this.index+"";
                if(index<10){
                    dayStr="0"+dayStr
                }
                var monthStr=""+this.month;
                if(this.month<10){
                    monthStr="0"+monthStr
                }
                var date=new Date(this.year+'-'+monthStr+'-'+dayStr);    
                var dayReport=undefined;
                for(var i=0;i<this.data.dayReportList.length;i++){
                        var item=this.data.dayReportList[i];
                        var  reportTime=new Date(item.reportTime) ;
                        if(formatTime(reportTime,'yyyy-MM-dd') == formatTime(date,'yyyy-MM-dd')){
                            dayReport=item;
                        }
                }
                if(dayReport==undefined){
                    this.data.reportData={reportDetailList:[]};
                }else{
                    this.data.reportData=dayReport;
                }
            },
            getDetailById(id){
                promise({
                    url:BASIC+'/dayReport/detail/mainId',
                    method:"get",
                    params:{mainId:this.form.id}
                }).then(res=>{
                    if(res.code==0 && res.data!=null){
                        this.data.reportData.reportDetailList=res.data;
                    }else{
                        this.data.reportData.reportDetailList=[];
                    }
                });
            },
            vueTouch:function(txt,e){
            if(txt=='左滑'){
                this.month+=1;
                if(this.month>12){
                    this.year+=1;
                    this.month=1;
                }
                this.dateRech(this.year,this.month);
            }else if(txt=='右滑'){
                this.month-=1;
                if(this.month<1){
                    this.year-=1;
                    this.month=12;
                }
                this.dateRech(this.year,this.month);
            }
        },
            formatDate(val){
                if(val==null || val==""){
                    return "";
                }
                return formatTime(val,'yyyy-MM-dd-');
            },
            compareDate(reportTime,createTime){
                return formatTime(new Date(reportTime),'yyyy-MM-dd')==formatTime(new Date(createTime),'yyyy-MM-dd')
            },
        },
        filters:{
            statusFilter(val){
                if(val=='已通过'){
                    return 'successStatus';
                }
                if(val=='被驳回'){
                    return 'refuseStatus';
                }
                if(val=='待审批'){
                    return 'waitStatus';
                }
            },
            dateFilter(val){
                if(val==null || val==""){
                    return "";
                }
                return formatTime(val,'yyyy年MM月dd日');
            },
            timeFilter(val){
                if(val==null || val==""){
                    return "";
                }
                return formatTime(val,'hh:mm');
            },

        },
        created(){

        },
        mounted(){
            var data= new Date();
            if(this.calDate!=null && this.calDate!=undefined){
                data=new Date(this.calDate);
            }
            var year =data.getFullYear();
            var month=data.getMonth()+1;
            var day=data.getDate();
            this.year=year;
            this.month=month;
            this.index=day;
            // this.getInfo(day);
            this.dateRech(this.year,this.month);
        }
    }



// WEBPACK FOOTER //
// ./src/view/sign/dayReportList.vue